import React from "react";

const Footer = ({ extraMargin }) => {
  return (<>   
    <div
      className={`lg:hidden flex flex-col gap-[25px] place-items-center bg-[var(--color-primary-purple)] w-full h-auto py-4`}
      style={{gridTemplateRows:'auto'}}
      >
      <div className='text-white flex w-full px-6 items-start justify-center gap-[20px] items-center'>
          <img
            alt=''
            className='h-[55px] w-auto my-2'
            src='/images/acgt_white_logo_2.png'
          />
           {/* <img
            alt=''
            className='h-[50px] w-auto my-2'
            src='/images/CAP-accredited-logo_RGB_white.png'
          /> */}
       
      </div>

      <div className="flex w-full md:w-[80%] justify-around text-white px-4 text-[14px]">
        <a href='https://acgtinc.com/' className='font-semibold'>Home</a>
        <a href='https://acgtinc.com/quality-management-system/' className='font-semibold'>Quality</a>
        <a href='https://acgtinc.com/company/' className='font-semibold'>Company</a>
        <a href='https://acgtinc.com/terms-of-service/' className='font-semibold'>Terms of Service</a> 
      </div>
      <div className="flex w-full md:w-[80%] justify-around text-white px-4 text-[14px]">
        <a href='https://acgtinc.com/careers/' className='font-semibold'>Careers</a>
        <a href='https://acgtinc.com/privacy-policy/' className='font-semibold'>Privacy Policy</a>
        <a href='https://acgtinc.com/contact-us/' className='font-semibold'>Contact Us</a>
        <a href='https://acgtinc.com/resources/faqs/' className='font-semibold'>FAQs</a> 
      </div>

      {/* <div className='text-white flex flex-col text-center md:w-[60%]'>
          <p className='tracking-wider font-light text-[14px] font-semibold'>Offices</p>
          <div className="px-2 flex justify-between gap-[25px] text-left">
            <div className="pl-1">
                <p className=' font-light text-[13px]'>Headquarters & Lab</p>
                <p className=' font-light text-[13px]'>
                  35 Waltz Drive <br /> Wheeling, IL 60090
                </p>
            </div>
            <div>
                <p className=' font-light text-[13px]'>
                  Germantown, MD Lab <br /> 12321 Middlebrook Road, Ste 105
                  <br /> Germantown, MD 20874
                </p>
            </div>
          </div>

        </div> */}
        
        <div className='text-white flex flex-col text-center md:w-[60%]'>
          <p className=' tracking-wider font-light text-[14px] font-semibold'>Get In Touch</p>
          <div className="flex justify-around gap-[20px] ">
              <div className="mt-2 text-center">
                <p className='text-[14px] font-light tracking-wider'>Headquarters & Laboratory</p>
                <p className='text-[14px] font-light tracking-wider'>35 Waltz Drive</p>
                <p className='text-[14px] font-light tracking-wider'>Wheeling, IL 60090</p>
                <p className='mt-2 text-[14px] font-light tracking-wider'>Toll-Free: (800) 557-2248</p>
                <p className='mt-2 text-[14px] font-light tracking-wider'>Direct Phone: (847) 520-9162</p>
              </div>
              {/* <div className="text-left">
                <p className='text-[14px] font-light tracking-wider'>Fax: <br/>(847) 520-9163</p>
                <p className=' mt-2 text-[14px] font-light tracking-wider'>Email: <br/>sanger@acgtinc.com</p>
              </div> */}
          </div>
        </div>


      <div className='row-start-3 text-white w-[40%]'>
        {/* <p className='text-xl font-semibold text-center'>Follow Us</p> */}
        <div className='flex justify-center items-center mt-2'>
                <a href="https://www.facebook.com/acgtinc/" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2 !ml-0'
                    src='/images/fb_2.png'
                  />
                </a>
                <a href="https://www.linkedin.com/company/acgt-inc-/" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2'
                    src='/images/linkedin_2.png'
                  />
                </a>
                <a href="https://www.instagram.com/acgt.dna.sequencing/#" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2'
                    src='/images/insta_logo_2.png'
                  />
                </a>
                <a href="https://www.youtube.com/@acgtinc.7684" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2 !mr-0'
                    src='/images/youtube-white.png'
                  />
                </a>
            </div>
      </div>
    </div>


    <div
      className={`hidden lg:flex justify-between lg:gap-[50px] xl:gap-[70px] 2xl:gap-[130px] items-center bg-[var(--color-primary-purple)] w-full py-3 px-8 xl:px-24 2xl:px-36`}
      >

        <div className="w-[30%] 2xl:w-[25%] flex justify-between">
            <div className='text-white flex items-center w-full'>
            <img
              alt=''
              className='max-h-16 w-auto mr-8 xl:mr-10'
              src='/images/acgt_white_logo_2.png'
            />
            {/* <img
                alt=''
                className='h-[45px] xl:h-[55px] w-auto my-2'
                src='/images/CAP-accredited-logo_RGB_white.png'
              />
               */}
          </div>

          <div className="w-[1px] h-44 bg-white place-self-center mx-8"></div>
        </div>

        <div className="w-[70%]  flex justify-between gap-[20px]">

          <div className="text-white w-[30%] mr-8">
            <p className='font-semibold tracking-wider pb-[10px]'>Quick Links</p>
            <div className="flex w-full pb-[8px]">
              <a href="https://acgtinc.com/" className='tracking-wider font-normal text-[14px] w-[300px]'>Home</a>
              <a href="https://acgtinc.com/quality-management-system/" className='tracking-wider font-normal text-[14px] w-[300px]'>Quality</a>
            </div>
            <div className="flex w-full pb-[8px]">
              <a href="https://acgtinc.com/company/" className='tracking-wider font-normal text-[14px] w-[300px]'>Company</a>
              <a href="https://acgtinc.com/terms-of-service/" className='tracking-wider font-normal text-[14px] w-[300px]'>Terms of Service</a>
            </div>
            <div className="flex w-full pb-[8px]">
              <a href="https://acgtinc.com/careers/" className='tracking-wider font-normal text-[14px] w-[300px]'>Careers</a>
              <a href="https://acgtinc.com/privacy-policy/" className='tracking-wider font-normal text-[14px] w-[300px]'>Privacy Policy</a>
            </div>
            <div className="flex w-full">
              <a href="https://acgtinc.com/contact-us/" className='tracking-wider font-normal text-[14px] w-[300px]'>Contact Us</a>
              <a href="https://acgtinc.com/resources/faqs/" className='tracking-wider font-normal text-[14px] w-[300px]'>FAQs</a>
            </div>
          </div>


          <div className="text-white w-1/3">
            <p className='font-semibold tracking-wider pb-[10px]'>Get In Touch</p>
            <div className="flex w-full pb-[6px]">
              <p className=' tracking-wider font-light text-[13px] w-[300px]'>Headquarters & Laboratory<br/>35 Waltz Drive</p>
            </div>
            <div className="flex w-full pb-[6px]">
              <p className=' tracking-wider font-light text-[13px] w-[300px]'>Wheeling, IL 60090</p>
            </div>
            <div className="flex w-full pb-[6px]">
              <p className=' tracking-wider font-light text-[13px] w-[300px]'>Toll-Free: (800) 557-2248</p>
            </div>
            <div className="flex w-full">
              <p className=' tracking-wider font-light text-[13px] w-[300px]'>Direct Phone: (847) 520-9162</p>
            </div>
            <div className='flex justify-start items-center mt-2'>
                <a href="https://www.facebook.com/acgtinc/" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2 !ml-0'
                    src='/images/fb_2.png'
                  />
                </a>
                <a href="https://www.linkedin.com/company/acgt-inc-/" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2'
                    src='/images/linkedin_2.png'
                  />
                </a>
                <a href="https://www.instagram.com/acgt.dna.sequencing/#" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2'
                    src='/images/insta_logo_2.png'
                  />
                </a>
                <a href="https://www.youtube.com/@acgtinc.7684" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2 !mr-0'
                    src='/images/youtube-white.png'
                  />
                </a>
            </div>
          </div>


          <div className="text-white w-1/3">
            <p className='font-semibold tracking-wider pb-[15px]'>Proud Member of<br/>Scientist.com</p>
            <img
              alt=''
              className='h-20 xl:h-28 w-auto'
              src='/images/scientist_2.png'
            />
          </div>

            {/* <div className='text-white flex flex-col self-start mt-2 gap-[10px] text-[14px] xl:w-[160px] mr-16'>
              <a href='https://www.acgtinc.com/us/' className='font-semibold tracking-wider '>About Us</a>
              <a href='https://www.acgtinc.com/resource/' className='font-semibold tracking-wider '>Resources</a>
              <a href='https://www.acgtinc.com/careers/' className='font-semibold tracking-wider '>Careers</a>
              <a href='https://www.acgtinc.com/contact/' className='font-semibold tracking-wider '>Support</a>   
            </div> */}

          {/* <div className='text-white self-start mt-2 flex flex-col w-[250px] gap-[5px]'>
            <p className='text-[14px] font-semibold'>Offices</p>
            <div>
              <p className=' tracking-wider font-light text-[13px]'>Headquarters & Laboratory</p>
              <p className=' tracking-wider font-light text-[13px]'>
                35 Waltz Drive <br /> Wheeling, IL 60090
              </p>
            </div>
            <div className="mt-2">
              <p className='tracking-wider font-light text-[13px]'>Germantown, MD Laboratory</p>
              <p className=' tracking-wider font-light text-[13px]'>
              12321 Middlebrook Road, Ste 105 <br /> Germantown, MD 20874
              </p>
            </div>
          </div> */}

            {/* <div className='text-white self-start mt-2 flex flex-col gap-[5px] w-[300px]'>
              <p className='text-[14px] font-semibold'>Contact Us</p>
              <div className="flex justify-between">
                <div>
                  <p className=' text-[13px] font-light tracking-wider'>Toll-Free: <br/>(800) 557-2248</p>
                  <p className='  mt-2 text-[13px] font-light tracking-wider'>Direct Phone: <br/>(847) 520-9162</p>
                </div>
                <div>
                <p className='text-[13px] font-light tracking-wider'>Fax: <br/>(847) 520-9163</p>
                <p className=' mt-2 text-[13px] font-light tracking-wider'>Email: <br/>sanger@acgtinc.com <br/>ngs@acgtinc.com</p>
                </div>
              </div>  
              <div className='flex justify-between w-[50%] self-end'>
                <a href="https://www.facebook.com/acgtinc/" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2'
                    src='/images/facebook.png'
                  />
                </a>
                <a href="https://www.youtube.com/channel/UCUmT2yM-VX0AeVe8ofRMHIQ" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2'
                    src='/images/youtube-white.png'
                  />
                </a>
                <a href="https://www.linkedin.com/company/acgt-inc-/" target="_blank" rel="noopener noreferrer">
                  <img
                    alt=''
                    className='h-7 m-2 !mr-0'
                    src='/images/linkedin_white.png'
                  />
                </a>
              
                
              </div>
            </div> */}
        </div>
      

     

    </div>
    {/* <div className={`w-full h-[50px] bg-[#FFDEDE] mb-[0px] ${extraMargin ? 'lg:mb-[91px]':''}`}></div> */}
    <div className={`w-full h-[20px] bg-[var(--color-primary-purple)] mb-[0px] ${extraMargin ? 'lg:mb-[91px]':''}`}></div>
    </>
  );
};

export default Footer;
